import { type FC } from 'react';

import clsx from 'clsx';
import times from 'lodash/times';

import { Grid } from '@/components/common/Grid';
import { type WithClassName } from '@/types/react';

import styles from './Stepper.module.scss';

type StepperProps = WithClassName & {
  currentStep: number;
  stepsCount: number;
};

export const Stepper: FC<StepperProps> = (props) => {
  const { className, currentStep, stepsCount } = props;

  return (
    <Grid className={className} gap={4} columnsTemplate={`repeat(${stepsCount}, 1fr)`}>
      {times(stepsCount, (index) => (
        <div
          key={index}
          className={clsx(styles.step, {
            [styles.isFuture]: index > currentStep,
          })}
        />
      ))}
    </Grid>
  );
};
